import { Button, Dialog, Avatar, Box, Grid, TextField, Typography, Alert, Divider, Stack } from '@mui/material';
import { useState } from 'react';
import AddBusinessIcon from '@mui/icons-material/AddBusiness';
import { MyTextField, SingleSelector } from '../../../Component/MuiEx';
import { apiResult, formToJson, getUserSession } from '../../../Utils/Common';
import apis from '../../../api';
const AddCompanyDialog = (props) => {
    const [error, setError] = useState()
    const [fieldErrors, setFieldErrors] = useState()

    const session = getUserSession(apis)

    const handleOnSubmit = (event) => {
        setError()
        setFieldErrors()
        event.preventDefault();

        const data = new FormData(event.currentTarget);
        let postData = formToJson(data)
        apis.addCompany(postData).then(ret => {
            apiResult(ret, (data) => {
                props.onSubmit && props.onSubmit(data)
            }, setError, setFieldErrors)
        })
    }
    return (<Dialog open={props.open} onClose={props.onClose}>
        <Box sx={{ marginTop: 2, display: 'flex', flexDirection: 'column', alignItems: 'center', width: 600, mb: 3 }}>
            <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}><AddBusinessIcon /></Avatar>
            <Typography component="h1" variant="h5">School Information</Typography>
            <Box component="form" onSubmit={handleOnSubmit} sx={{ p: 3, width: "100%" }}>
                <MyTextField fieldErrors={fieldErrors} required={true} fullWidth={true} id="name" label={"School name"} />
                <Typography variant='overline' color="text.secondary" >CONTACT INFORMATION</Typography>

                <Grid container spacing={2}>
                    <Grid item xs={12} sm={4}>
                        <MyTextField fieldErrors={fieldErrors} label={"Contact person"} id="contact_person" fullWidth={true} required={true} />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <MyTextField fieldErrors={fieldErrors} label={"Phone number"} id="contact_phone" fullWidth={true} required={true} />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <MyTextField fieldErrors={fieldErrors} label={"Email"} id="contact_email" fullWidth={true} required={true} />
                    </Grid>
                </Grid>

                <Typography variant='overline' color="text.secondary"  >SCHOOL ADDRESS</Typography>
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={8}>
                        <MyTextField fieldErrors={fieldErrors} label={"Street address ( No. Street )"} id="address" fullWidth={true} required={true} />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <MyTextField fieldErrors={fieldErrors} label={"City"} id="city" fullWidth={true} required={true} />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <MyTextField fieldErrors={fieldErrors} label={"Province"} id="province" fullWidth={true} required={true} />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <MyTextField fieldErrors={fieldErrors} label={"Country/State"} id="country" fullWidth={true} required={true} />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <MyTextField fieldErrors={fieldErrors} label={"Post code"} id="zipcode" fullWidth={true} required={true} />
                    </Grid>
                </Grid>
                <Stack direction={"column"}>
                    <Typography variant='overline' color="text.secondary" >SCHOOL ADDRESS</Typography>
                    <Typography variant='overline' color="text.secondary" sx={{ fontSize: "10px" }} >Please share some information about your school (vision, market capacity, revenue projections, expected resources, etc.).</Typography>
                    <MyTextField multiline id="description" name="description" rows={6} fullWidth={true}/>
                </Stack>
                {error && <Alert severity="error">{error}</Alert>}
                <Button type="submit" fullWidth variant="contained" sx={{ mt: 3 }} > Submit </Button>
                <Button fullWidth variant="outlined" sx={{ mt: 1 }} onClick={props.onClose}> Cancel </Button>
            </Box>
        </Box>
    </Dialog>)
}
export default AddCompanyDialog